import React, { Component, Fragment } from 'react';
import ReactGA from 'react-ga';

import Login from '../auth/login';
import FacebookAuthButton from '../auth/facebook';
import GoogleAuthButton from '../auth/google';
import TwitterAuthButton from '../auth/twitter';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import './login-page.css';

class LoginPage extends Component {

  render() {
    ReactGA.pageview('/login-page');
    return (
      <div className="login-page">
        <Fragment>
          <Login />
          <FacebookAuthButton />
          <GoogleAuthButton />
          <TwitterAuthButton />
        </Fragment>
      </div>
    )
  }
}

LoginPage.propTypes = {
  user: PropTypes.object
}

const mapStateToProps = (state) => {
  return {
    user: state.user
  };
};

const mapDispatchToProps = dispatch => {
  return {};
}

export default connect(mapStateToProps, mapDispatchToProps)(LoginPage);